import React, { useState } from "react";
import { Phone, ChatCircleText, CalendarCheck, X } from "@phosphor-icons/react";
import { useBooking } from "@/contexts/BookingContext";

const BUSINESS_PHONE_RAW = "+19197375442";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const { openBooking } = useBooking();

  const ACTIONS = [
    {
      icon: Phone,
      label: "Call Now",
      sub: "(919) 737-5442",
      onClick: () => { window.location.href = `tel:${BUSINESS_PHONE_RAW}`; },
      bg: "bg-blue-600 hover:bg-blue-700",
      testId: "float-call",
    },
    {
      icon: ChatCircleText,
      label: "Text Us",
      sub: "Reply in minutes",
      onClick: () => { window.location.href = `sms:${BUSINESS_PHONE_RAW}?body=Hi%20TechConnect%2C%20`; },
      bg: "bg-zinc-900 hover:bg-zinc-800",
      testId: "float-text",
    },
    {
      icon: CalendarCheck,
      label: "Book Online",
      sub: "Pick a date & time",
      onClick: () => { setOpen(false); openBooking(""); },
      bg: "bg-zinc-900 hover:bg-zinc-800",
      testId: "float-book",
    },
  ];

  return (
    <div className="fixed left-4 sm:left-6 bottom-6 z-40 flex flex-col items-start gap-3">
      {open && (
        <div className="flex flex-col gap-2.5 animate-fade-up" data-testid="floating-actions">
          {ACTIONS.map((a) => (
            <button
              key={a.label}
              onClick={a.onClick}
              data-testid={a.testId}
              className={`flex items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-xl shadow-zinc-950/25 text-white font-semibold text-sm transition-all ${a.bg}`}
            >
              <a.icon size={18} weight="fill" />
              <span className="flex flex-col items-start leading-tight">
                <span>{a.label}</span>
                <span className="text-[10.5px] font-normal opacity-80">{a.sub}</span>
              </span>
            </button>
          ))}
        </div>
      )}

      <button
        onClick={() => setOpen(!open)}
        data-testid="floating-contact-toggle"
        aria-label={open ? "Close contact options" : "Open contact options"}
        className={`group h-14 w-14 rounded-full grid place-items-center text-white shadow-2xl shadow-blue-900/40 transition-all ${
          open ? "bg-zinc-900 rotate-90" : "bg-blue-600 hover:bg-blue-700"
        }`}
      >
        {open
          ? <X size={22} weight="bold" />
          : <Phone size={22} weight="fill" className="animate-pulse" />}
      </button>
    </div>
  );
}
